import { inject, injectable } from '~/container'
import { PuLangFetch } from '~/lang/utils/pulangfetch'
import { PopularLocationsRepository } from './repositories'

@injectable()
export class PopularLocationsRepositoryFetch
implements PopularLocationsRepository
{
  @inject(PuLangFetch)
  private puLangFetch: PuLangFetch

  async fetch(langCode: string, limit: number) {
    return this.puLangFetch.fallbackFetch(
      langCode,
      `/search2/destinations/?limit=${limit}`,
    )
  }
}
